<template>
  <div>
    <modal id="add-tag">
      <h5 slot="header">
        <strong>Unesite novi tag</strong>
      </h5>
      <div slot="body">
        <div class="row">
          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Tag
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Tag"
                v-model="tagName"
              />
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.stop.prevent="saveTag()"
            >
              {{ translations.save }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.cancel }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal id="add-brand">
      <h5 slot="header">
        <strong>Unesite novi brend</strong>
      </h5>
      <div slot="body">
        <div class="row">
          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Naziv
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Brend"
                v-model="brand.title"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Opis</label>
            <div class="col-lg-7 col-xl-6">
              <textarea
                type="text"
                class="form-control form-control-modern"
                placeholder="Opis"
                v-model="brand.description"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Slika</label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="file"
                class="form-control form-control-modern"
                ref="brandImage"
                accept="image/*"
              />

              <span class="form-text">
                Učitajte sliku rezolucije 200px x 60px
              </span>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.stop.prevent="saveBrand()"
            >
              {{ translations.save }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.cancel }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- start: page -->
    <form
      @submit.prevent="submitForm"
      class="ecommerce-form action-buttons-fixed"
      novalidate
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    {{ translations.articleDetails }}
                  </h2>
                  <p class="card-big-info-desc">
                    {{ translations.articleDetailsInfo }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <!-- <div
                    class="form-group row align-items-center pb-3"
                    :class="{ 'has-danger': $v.companyId.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.company }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div :class="{ has__error: $v.companyId.$anyError }">
                        <treeselect
                          v-model="companyId"
                          :multiple="false"
                          :options="companies"
                          :show-count="true"
                          placeholder="Izaberite kompaniju"
                        />
                      </div>
                      <form-error
                        :model="$v.companyId"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.company"
                      />
                    </div>
                  </div> -->

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.code.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.code }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.code"
                        v-model="code"
                        @blur="checkIfArticleCodeExists"
                      />

                      <form-error
                        :model="$v.code"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.code"
                      />
                      <label v-if="articleCodeExists" class="article-code-error"
                        >{{ translations.forms.labels.articleCodeExists }}</label
                      >
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.title.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.title }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.title"
                        v-model="title"
                      />

                      <form-error
                        :model="$v.title"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.title"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      Status artikla
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="articleState"
                        :options="articleStates"
                        placeholder="Izaberite status artikla"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.isVisibleOnWeb }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="isVisibleOnWeb"
                          id="visible-on-web"
                        />
                        <label for="visible-on-web"></label>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{ 'has-danger': $v.categoryIds.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.category }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div :class="{ has__error: $v.categoryIds.$anyError }">
                        <treeselect
                          v-model="categoryIds"
                          :multiple="true"
                          :options="categoriesTreeView"
                          :show-count="true"
                          placeholder="Izaberite kategoriju"
                          v-if="categoriesTreeView"
                        />
                      </div>
                      <form-error
                        :model="$v.categoryIds"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.category"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.brand }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="brandId"
                      >
                        <option :value="null">Izaberite brend</option>
                        <option
                          :value="brand.id"
                          :key="brand.id"
                          v-for="brand in brands"
                        >
                          {{ brand.title }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-1 col-xl-1">
                      <button
                        class="btn btn-primary btn-md font-weight-semibold py-2 px-4"
                        type="button"
                        @click="addBrand()"
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.interestsArea }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="interestsAreasIds"
                        :multiple="true"
                        :options="areas"
                        placeholder="Izaberite djelatnost"
                        no-options-text="Nema unesenih djelatnosti."
                        @select="handleChangeAreas"
                      />
                    </div>
                  </div>


                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.catalogNumber }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.catalogNumber"
                        v-model="catalogNumber"
                      />

                      <!-- <form-error
                        :model="$v.catalogNumber"
                        :dirty="$v.$dirty"
                        label="Kataloški broj"
                      /> -->
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end pt-2 mt-1 mb-0"
                    >
                      {{ translations.forms.labels.shortDescription }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <editor
                        name="html-editor"
                        :init="{
                          ...appSettings.tinyMceConfig
                        }"
                        v-model="shortDescription"
                        id="description"
                      ></editor>

                      <!-- <form-error
                        :model="$v.shortDescription"
                        :dirty="$v.$dirty"
                        label="Kratak opis"
                      /> -->
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end pt-2 mt-1 mb-0"
                    >
                      {{ translations.forms.labels.description }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <editor
                        name="html-editor"
                        :init="{
                          ...appSettings.tinyMceConfig
                        }"
                        v-model="description"
                        id="short-description"
                      ></editor>

                      <!-- <form-error
                        :model="$v.description"
                        :dirty="$v.$dirty"
                        label="Opis"
                      /> -->

                      <div class="form-text">
                        Molimo koristite slike ne veće rezolucije od 600px x 600px
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3 d-none"
                    :class="{ 'has-danger': $v.nc.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.nc }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.nc"
                        v-model.number="nc"
                      />

                      <form-error
                        :model="$v.nc"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.nc"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.mpc.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.mpc }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.mpc"
                        v-model.number="mpc"
                        @input="handleMpcChange"
                      />

                      <form-error
                        :model="$v.mpc"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.mpc"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.taxGroup }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="taxId"
                      >
                        <option :value="null">Izaberite poreznu grupu</option>
                        <option
                          :value="tax.id"
                          :key="tax.id"
                          v-for="tax in taxes"
                        >
                          {{ tax.description }}
                        </option>
                      </select>

                      <!-- <form-error
                        :model="$v.taxId"
                        :dirty="$v.$dirty"
                        label="Porezna grupa"
                      /> -->
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.vpc.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.vpc }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.vpc"
                        v-model.number="vpc"
                        @input="handleVpcChange"
                      />

                      <form-error
                        :model="$v.vpc"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.vpc"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.unitOfMeasure }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="unitOfMeasureId"
                      >
                        <option :value="null">Izaberi jedinicu mjere</option>
                        <option
                          :value="unit.id"
                          :key="unit.id"
                          v-for="unit in measurementUnits"
                        >
                          {{ unit.description }}
                        </option>
                      </select>

                      <!-- <form-error
                        :model="$v.unitOfMeasureId"
                        :dirty="$v.$dirty"
                        label="Jedinica mjere"
                      /> -->
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.nettoWeight }} (kg)
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.nettoWeight"
                        v-model.number="nettoWeight"
                      />

                      <!-- <form-error
                        :model="$v.nettoWeight"
                        :dirty="$v.$dirty"
                        label="Netto težina"
                      /> -->
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.bruttoWeight }} (kg)
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.bruttoWeight"
                        v-model.number="bruttoWeight"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Omjer narudžbe
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        @change="handleOrderQuantityRatio"
                        placeholder="Omjer narudžbe"
                        v-model.number="orderQuantityRatio"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.minOrderQuantity.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Minimalna količina za narudžbu
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Minimalna količina za narudžbu"
                        @change="handleMinOrderQuantity"
                        v-model.number="minOrderQuantity"
                      />

                      <form-error
                        :model="$v.minOrderQuantity"
                        :dirty="$v.$dirty"
                        label="Minimalna količina za narudžbu"
                      />
                      <!-- <div class="form-text">
                        Ukoliko mijenjate polje "Omjer narudžbe" potrebno je promjeniti i ovo polje na istu vrijednost
                      </div> -->
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Maksimalna količina za narudžbu
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Maksimalna količina za narudžbu"
                        v-model.number="maxOrderQuantity"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Dužina
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Dužina"
                        v-model.number="length"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Širina
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Širina"
                        v-model.number="width"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Visina
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Visina"
                        v-model.number="height"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.videoUrl.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.videoUrl }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.videoUrl"
                        v-model="videoUrl"
                      />

                      <form-error
                        :model="$v.videoUrl"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.videoUrl"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.articleType }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="attributeArticleType"
                        :options="attributeArticleTypes"
                        :clearable="false"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.tag }}
                    </label>
                    <div class="col-lg-6 col-xl-6">
                      <treeselect
                        v-model="tagsIds"
                        :multiple="true"
                        :options="tags"
                        placeholder="Tagovi"
                      />
                    </div>
                    <div class="col-lg-1 col-xl-1">
                      <button
                        class="btn btn-primary btn-md font-weight-semibold py-2 px-4"
                        type="button"
                        @click="addTag()"
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Broj dana nakon kojih je artikal dostupan
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Broj dana nakon kojih je artikal dostupan"
                        v-model="articleAvailableInDays"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.markArticleAsNew }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="isNewArticle"
                          id="mark-as-new"
                        />
                        <label for="mark-as-new"></label>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="isNewArticle"
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Početak
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <datepicker
                        placeholder="Početak"
                        v-model="isNewArticleFromDate"
                        input-class="form-control form-control-modern bg-body"
                        :monday-first="true"
                        :full-month-name="true"
                        :language="bs"
                        :format="customFormatter"
                        :disabled-dates="disabledDates"
                      ></datepicker>
                    </div>
                  </div>

                  <div
                    v-if="isNewArticle"
                    class="form-group row align-items-center mb-3"
                  >
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      Kraj
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <datepicker
                        placeholder="Kraj"
                        v-model="isNewArticleToDate"
                        input-class="form-control form-control-modern bg-body"
                        :monday-first="true"
                        :full-month-name="true"
                        :language="bs"
                        :format="customFormatter"
                        :disabled-dates="disabledDates"
                      ></datepicker>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Omogući prezentaciju artikla
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="presentationAvailable"
                          id="presentation-available"
                        />
                        <label for="presentation-available"></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Onemogući prodaju B2B
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="disableSelling"
                          id="disable-selling"
                        />
                        <label for="disable-selling"></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Onemogući prodaju B2C
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="disableSellingB2C"
                          id="disable-selling-b2c"
                        />
                        <label for="disable-selling-b2c"></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Dozvoli recenzije
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="reviewAllowed"
                          id="review-allowed"
                        />
                        <label for="review-allowed"></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      B2C Proizvod
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="b2CProduct"
                          id="b2c-product"
                        />
                        <label for="b2c-product"></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      B2B Proizvod
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="b2BProduct"
                          id="b2b-product"
                        />
                        <label for="b2b-product"></label>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>

          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-detail"></i>
                  <h2 class="card-big-info-title">Tabovi</h2>
                  <p class="card-big-info-desc">Dodajte zeljene tabove</p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center">
                    <div class="col">
                      <div class="form-group row align-items-center pb-3">
                        <div class="col-4">
                          <select
                            class="form-control form-control-modern"
                            v-model="tabId"
                          >
                            <option :value="null">Izaberite tab</option>
                            <option
                              :value="tab.id"
                              :key="tab.id"
                              v-for="tab in tabs"
                            >
                              {{ tab.title }}
                            </option>
                          </select>
                        </div>
                        <div class="col-1">
                          <button
                            class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4"
                            type="button"
                            @click="addTab()"
                          >
                            +
                          </button>
                        </div>
                      </div>

                      <div class="tabs" v-if="editors.length > 0">
                        <ul class="nav nav-tabs">
                          <li
                            class="nav-item"
                            v-for="(tab, index) in editors"
                            :key="tab.id"
                          >
                            <a
                              class="nav-link"
                              :class="{ active: editors.length === index + 1 }"
                              :data-bs-target="`#tab${tab.id}`"
                              :href="`#tab${tab.id}`"
                              data-bs-toggle="tab"
                            >
                              {{ tab.title }}
                            </a>
                            <span
                              class="remove-tab"
                              @click.prevent.stop="removeTab(index)"
                              ><i class="bx bx-x"></i
                            ></span>
                          </li>
                        </ul>
                        <div class="tab-content">
                          <div
                            :id="`tab${tab.id}`"
                            class="tab-pane"
                            :class="{ active: editors.length === index + 1 }"
                            v-for="(tab, index) in editors"
                            :key="tab.id"
                          >
                            {{ tab.description }}
                            <editor
                              name="html-editor"
                              :init="{
                                ...appSettings.tinyMceConfig
                              }"
                              v-model="tab.content"
                              :id="`editor-${tab.id}`"
                            ></editor>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="tabs-modern row" style="min-height: 490px">
                <div class="col-lg-2-5 col-xl-1-5">
                  <div
                    class="nav flex-column tabs"
                    id="tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <a
                      class="nav-link active"
                      id="attributes-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#attributes"
                      role="tab"
                      aria-controls="attributes"
                      >Atributi</a
                    >
                    <a
                      class="nav-link"
                      id="variation-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#advanced"
                      role="tab"
                      aria-controls="advanced"
                      >Varijacije</a
                    >
                  </div>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="tab-content" id="tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="attributes"
                      role="tabpanel"
                      aria-labelledby="attributes-tab"
                    >
                      <div class="form-group row">
                        <div class="col">
                          <div class="form-group row pb-3">
                            <div class="form-group row align-items-center pb-3">
                              <div class="col-4">
                                <select
                                  class="form-control form-control-modern"
                                  v-model="attributeId"
                                >
                                  <option :value="null">
                                    Izaberite atribut
                                  </option>
                                  <option
                                    :value="item.id"
                                    :key="item.id"
                                    v-for="item in attributes"
                                  >
                                    {{ item.title }}
                                  </option>
                                </select>
                              </div>
                              <div class="col-1">
                                <button
                                  class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4"
                                  type="button"
                                  @click="addAttribute()"
                                >
                                  +
                                </button>
                              </div>
                            </div>

                            <div
                              v-if="
                                linkedAttributes.length > 0
                              "
                              class="mt-5"
                            >
                              <div
                                class="form-group row pb-3"
                                v-for="item in linkedAttributes.filter((item) => item.linkWithArticle === true)"
                                :key="item.id"
                              >
                                <div v-for="property in item.attributePropertiesLinkedWithArticle" 
                                :key="property.id">
                                  <div class="col-xl-2">
                                    <label
                                      v-if="
                                        attributesObj &&
                                        attributesObj[item.id]
                                      "
                                    >
                                      {{ attributesObj[item.id].title }}
                                    </label>
                                  </div>
                                  <div class="col-xl-2">
                                    <label class="control-label"
                                      >Vrijednost(i)</label
                                    >
                                      <treeselect
                                        v-model="property.id"
                                        :options="
                                          attributesObj[item.id]
                                            .attributeProperties
                                        "
                                        :disabled="property.id != null"
                                        @select="onAttributePropertySelect"
                                      >
                                        <label
                                          slot="option-label"
                                          slot-scope="{ node, labelClassName }"
                                          :class="labelClassName"
                                        >
                                          <div
                                            v-if="
                                              attributesObj[item.id]
                                                .attributeStyle !== 1
                                            "
                                          >
                                            {{ node.label }}
                                          </div>
                                          <div v-else>
                                            <div
                                              :style="{
                                                height: '20px',
                                                width: '20px',
                                                background: node.label,
                                              }"
                                            ></div>
                                          </div>
                                        </label>
                                        <div
                                          slot="value-label"
                                          slot-scope="{ node }"
                                          :style="{
                                            paddingTop: '10px'
                                          }"
                                        >
                                          <div
                                            v-if="
                                              attributesObj[item.id]
                                                .attributeStyle === 1
                                            "
                                            :style="{
                                              backgroundColor: node.label,
                                              width: '20px',
                                              height: '20px',
                                              overflow: 'hidden',
                                              border: node.label == '#ffffff' ? '1px solid grey' :'none',
                                            }"
                                          ></div>
                                          <div v-else>{{ node.label }}</div>
                                        </div>
                                      </treeselect>
                                  </div>
                                  <div
                                  class="col-xl-8">
                                    <div
                                      data-bs-toggle="modal"
                                      data-bs-target="#delete-attribute-linked-with-article-modal"
                                      @click="selectAttributeLinkedArticle(item.attributeId, property.id)"
                                      class="ecommerce-attribute-remove text-color-danger float-end"
                                    >
                                      Ukloni
                                    </div>
                                    <label class="control-label"
                                      >Povezani artikal</label
                                    >
                                    <div class="form-group d-flex col-12">
                                              <div class="col-4">
                                                <img
                                                  v-if="property.articleImage != null && property.articleImage != ''"
                                                  class="img-thumbnail article-attribute-thumbnail-sm"
                                                  :src="`${baseUrl}${property.articleImage}`"
                                                />
                                                <div
                                                  v-else
                                                  style="background-color: lightgray;"
                                                  class="img-thumbnail article-attribute-thumbnail-sm text-light d-flex align-items-center
                                                  justify-content-center"
                                                >
                                                  <p v-if="property.articleImage == null">Bez slike</p>
                                                  <p v-else class="text-light">Slika</p>
                                                </div>
                                              </div>
                                  
                                              <div class="col-8">
                                                <div>
                                                  <div class=" row align-items-center mb-1">
                                                    <label class="col-2 control-label text-lg-end mb-0">
                                                      Naziv
                                                    </label>
                                                    <div class="col-10">
                                                      <input
                                                        type="text"
                                                        class="form-control form-control-modern"
                                                        readonly
                                                        placeholder="Naziv"
                                                        v-model="property.articleTitle"
                                                      />
                                                    </div>
                                                  </div>
                                  
                                                  <div class=" row align-items-center mb-1">
                                                    <label class="col-2 control-label text-lg-end mb-0">
                                                      Šifra
                                                    </label>
                                                    <div class="col-10">
                                                      <input
                                                        type="text"
                                                        class="form-control form-control-modern"
                                                        readonly
                                                        placeholder="Šifra"
                                                        v-model="property.articleCode"
                                                      />
                                                    </div>
                                                  </div>
                                  
                                                  <div class=" row align-items-center mb-1">
                                                    <label class="col-2 control-label text-lg-end mb-0">
                                                      Cijena
                                                    </label>
                                                    <div class="col-3">
                                                      <input
                                                        readonly
                                                        type="text"
                                                        class="form-control form-control-modern"
                                                        placeholder="Cijena"
                                                        v-model.number="property.articlePrice"
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="form-group row pb-3"
                                v-for="(
                                  item, index
                                ) in linkedAttributes.filter((item) => item.linkWithArticle === false)"
                                :key="item.id"
                              >
                                <div class="col-xl-3">
                                  <label
                                    v-if="
                                      attributesObj &&
                                      attributesObj[item.id]
                                    "
                                  >
                                    {{ attributesObj[item.id].title }}
                                  </label>
                                </div>
                                <div :class="{
                                  'col-xl-2': attributesObj &&
                                  attributesObj[item.id] &&
                                  attributesObj[item.id].linkWithArticle,
                                  'col-xl-6': attributesObj &&
                                  attributesObj[item.id] &&
                                  attributesObj[item.id].linkWithArticle == false,
                                }">
                                  <div
                                  v-if="attributesObj[item.id] &&
                                  attributesObj[item.id].linkWithArticle == false"
                                    data-bs-toggle="modal"
                                    data-bs-target="#delete-attribute-modal"
                                    @click="selectLinkedAttribute(item.attributeId)"
                                    class="ecommerce-attribute-remove text-color-danger float-end"
                                  >
                                    Ukloni
                                  </div>

                                  <label class="control-label"
                                    >Vrijednost(i)</label
                                  >

                                  <treeselect
                                    v-if="
                                      attributesObj &&
                                      attributesObj[item.id] &&
                                      attributesObj[item.id].linkWithArticle
                                    "
                                    :instance-id="item.id"
                                    v-model="attributesObj[item.id].attributeProperties[0]"
                                    :options="
                                      attributesObj[item.id]
                                        .attributeProperties
                                    "
                                    @deselect="onAttributeChange"
                                    @select="onAttributePropertySelect"
                                  >
                                    <label
                                      slot="option-label"
                                      slot-scope="{ node, labelClassName }"
                                      :class="labelClassName"
                                    >
                                      <div
                                        v-if="
                                          attributesObj[item.id]
                                            .attributeStyle !== 1
                                        "
                                      >
                                        {{ node.label }}
                                      </div>
                                      <div v-else>
                                        <div
                                          :style="{
                                            height: '20px',
                                            width: '20px',
                                            background: node.label,
                                          }"
                                        ></div>
                                      </div>
                                    </label>

                                    <div
                                      slot="value-label"
                                      slot-scope="{ node }"
                                      :style="{
                                        paddingTop: '10px'
                                      }"
                                    >
                                      <div
                                        v-if="
                                          attributesObj[item.id]
                                            .attributeStyle === 1
                                        "
                                        :style="{
                                          backgroundColor: node.label,
                                          width: '20px',
                                          height: '20px',
                                          overflow: 'hidden',
                                          border: node.label == '#ffffff' ? '1px solid grey' :'none',
                                        }"
                                      ></div>
                                      <div v-else>{{ node.label }}</div>
                                    </div>
                                  </treeselect>
                                  <treeselect
                                    v-if="
                                      attributesObj &&
                                      attributesObj[item.id] &&
                                      attributesObj[item.id].linkWithArticle == false
                                    "
                                    :instance-id="item.id"
                                    v-model="item.attributeValues"
                                    :multiple="true"
                                    :options="
                                      attributesObj[item.id]
                                        .attributeProperties
                                    "
                                    @deselect="onAttributeChange"
                                  >
                                    <label
                                      slot="option-label"
                                      slot-scope="{ node, labelClassName }"
                                      :class="labelClassName"
                                    >
                                      <div
                                        v-if="
                                          attributesObj[item.id]
                                            .attributeStyle !== 1
                                        "
                                      >
                                        {{ node.label }}
                                      </div>
                                      <div v-else>
                                        <div
                                          :style="{
                                            height: '20px',
                                            width: '20px',
                                            background: node.label,
                                          }"
                                        ></div>
                                      </div>
                                    </label>

                                    <div
                                      :style="{
                                        background: node.label,
                                      }"
                                      slot="value-label"
                                      slot-scope="{ node }"
                                    >
                                      <div
                                        v-if="
                                          attributesObj[item.id]
                                            .attributeStyle === 1
                                        "
                                        :style="{
                                          backgroundColor: node.label,
                                          width: '20px',
                                          height: '20px',
                                          overflow: 'hidden',
                                        }"
                                      ></div>
                                      <div v-else>{{ node.label }}</div>
                                    </div>
                                  </treeselect>
                                </div>
                                <div 
                                v-if="
                                      attributesObj &&
                                      attributesObj[item.id] &&
                                      attributesObj[item.id].linkWithArticle
                                    "
                                class="col-xl-6">
                                  <div
                                    data-bs-toggle="modal"
                                    data-bs-target="#delete-attribute-modal"
                                    @click="selectLinkedAttribute(index)"
                                    class="ecommerce-attribute-remove text-color-danger float-end"
                                  >
                                    Ukloni
                                  </div>

                                  <label class="control-label"
                                    >Povezani artikal</label
                                  >

                                  <div class="form-group d-flex col-12">
            <div class="col-4">
              <img
                v-if="attributesObj[item.id].attributeProperties[0]?.articleImage"
                class="img-thumbnail article-attribute-thumbnail-sm"
                :src="`${baseUrl}${attributesObj[item.id].attributeProperties[0]?.articleImage}`"
              />
              <div
                v-else
                style="background-color: lightgray;"
                class="img-thumbnail article-attribute-thumbnail-sm text-light d-flex align-items-center
                justify-content-center"
              >
                <p v-if="attributesObj[item.id].attributeProperties[0] == null">Bez slike</p>
                <p v-else class="text-light">Slika</p>
              </div>
            </div>

            <div class="col-8">
              <div>
                <div class=" row align-items-center mb-1">
                  <label class="col-2 control-label text-lg-end mb-0">
                    Naziv
                  </label>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      placeholder="Naziv"
                      v-model="attributesObj[item.id].attributeProperties[0].articleTitle"
                    />
                  </div>
                </div>

                <div class=" row align-items-center mb-1">
                  <label class="col-2 control-label text-lg-end mb-0">
                    Šifra
                  </label>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      placeholder="Šifra"
                      v-model="attributesObj[item.id].attributeProperties[0].articleCode"
                    />
                  </div>
                </div>

                <div class=" row align-items-center mb-1">
                  <label class="col-2 control-label text-lg-end mb-0">
                    Cijena
                  </label>
                  <div class="col-3">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      placeholder="Cijena"
                      v-model.number="attributesObj[item.id].attributeProperties[0].articlePrice"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="tab-pane fade" id="advanced" role="tabpanel">
                      <div class="form-group row pb-3">
                        <div class="row mt-1">
                          <div class="form-group row align-items-center mb-3">
                            <!-- <div class="col col-4" v-for="item in variationAttributes" :key="item.id">
                              <label class="label">{{ item.label }}</label>
                              <select class="form-control" :key="item.id" v-model="item.model">
                                <option :value="null">Bilo koja vrijednost</option>
                                <option
                                  :value="v.id"
                                  v-for="v in item.values"
                                  :key="v.id"
                                >
                                  {{ v.label }}
                                </option>
                              </select>
                            </div> -->
                          </div>
                          <div class="col-md-auto">
                            <button
                              class="btn btn-primary btn-px-3 py-3 font-weight-semibold"
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#add-variation-modal"
                              @click="addVariation()"
                            >
                              Dodaj varijaciju
                            </button>
                          </div>
                        </div>
                      </div>

                      <!-- <div class="accordion">
                          <div class="accordion-item mb-2" v-for="(item, index) in variations" :key="index">
                            <div class="accordion-header" :id="`panel-${index}`">
                              <button
                                class="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                :data-bs-target="`#panel-body-${index}`"
                              >
                                RBr #{{ index + 1 }}
                              </button>
                            </div>
                            <div
                              :id="`panel-body-${index}`"
                              class="accordion-collapse collapse show"
                            >
                              <div class="accordion-body">
                                PRIKAZI PODATKE O VARIJACIJAMA
                                <div class="col-md-auto">
                                  <button class="btn btn-primary btn-px-3 py-3 font-weight-semibold"
                                    type="button"
                                    data-bs-toggle="modal"
                                    data-bs-target="#update-variation-modal"
                                    @click="addVariation(item)"
                                  >Ažuriraj varijaciju</button>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div> -->

                      <div class="table-responsive">
                        <table
                          class="table table-hover table-bordered table-variations"
                          style="min-width: 550px"
                        >
                          <thead>
                            <tr role="row">
                              <th>Cijena</th>
                              <th>Cijena na popustu</th>
                              <th>Kôd</th>
                              <th>Opis</th>
                              <th>Količina na zalihi</th>
                              <th>Dimenzije (DxŠxV)</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, index) in variations"
                              :key="item.id"
                              :class="{
                                odd: index % 2 === 0,
                                even: index % 2 !== 0,
                              }"
                              data-bs-toggle="modal"
                              data-bs-target="#update-variation-modal"
                              @click="addVariation(item)"
                            >
                              <td>
                                {{ item.mpc }}
                              </td>

                              <td>
                                {{ item.salePrice }}
                              </td>

                              <td>
                                {{ item.code }}
                              </td>

                              <td
                                class="text-hidden"
                                :title="item.shortDescription"
                              >
                                {{ item.description || "N/A" }}
                              </td>

                              <td>
                                {{ item.stockAmount }}
                              </td>

                              <td>
                                {{ item.length }} x {{ item.width }} x
                                {{ item.height }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <linked-articles v-model="linkedArticles" />

          <section
            class="card card-modern card-big-info mb-4"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-camera"></i>
                  <h2 class="card-big-info-title">Slike artikla</h2>
                  <p class="card-big-info-desc">Označite sliku kao glavnu ili dodajte nove iz galerije</p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center" v-if="gallery.length">
                    <div class="col">
                      <div class="popup-gallery row">
                        <div
                          class="img-fluid col-xs-4 col-auto mb-4 me-1 img-wrapper"
                          v-for="image in gallery"
                          @click.stop="highlightImage(image.id)"
                          :key="image.id"
                        >
                          <div
                            class="delete-image"
                            @click.prevent.stop="deleteImage(image.id)"
                          >
                            <i class="bx bx-x"></i>
                          </div>
                          <img
                            class="img-thumbnail img-thumbnail-custom"
                            :src="`${baseUrl}${image.url}`"
                            :class="{ highlighted: image.isHighlighted }"
                          />
                          <input
                            class="form-control form-control-modern img-order"
                            type="text"
                            v-model.number="image.ordinalNumber"
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center">
                    <button
                      data-bs-toggle="modal"
                      type="button"
                      data-bs-target="#media-library"
                      class="
                        btn btn-primary btn-md
                        font-weight-semibold
                        btn-py-2
                        px-4
                      "
                    >
                      <i class="bx bx-upload text-lg-4 py-1" /> Upload
                    </button>
                    <modal id="media-library" css-class="modal-xl">
                      <h5 slot="header">
                        <strong>Biblioteka</strong>
                      </h5>
                      <div slot="body">
                        <media-library v-model="gallery" />
                      </div>
                      <div slot="footer">
                        <div class="row">
                          <div class="col-md-12 text-end">
                            <button
                              type="button"
                              class="btn btn-primary px-4 mx-2"
                              @click.prevent="closeMediaLibraryModal"
                            >
                              Zatvori
                            </button>
                          </div>
                        </div>
                      </div>
                    </modal>
                    <modal id="upload-modal" css-class="modal-xl">
                      <h5 slot="header">
                        <strong> Upload image </strong>
                      </h5>
                      <div slot="body">
                        <MediaLibraryModalBody modal-id="upload-modal" />
                      </div>
                      <div slot="footer">
                        <div class="row">
                          <div class="col-md-12 text-end">
                            <button
                              type="button"
                              class="btn btn-primary px-4 mx-2"
                              @click.prevent="closeUploadModal('upload-modal')"
                            >
                              Zatvori
                            </button>
                          </div>
                        </div>
                      </div>
                    </modal>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <button
            type="button"
            @click="$router.go(-1)"
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
          >
            {{ translations.cancel }}
          </button>
          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>

      <modal id="delete-attribute-modal">
        <h5 slot="header">
          <strong>{{ translations.deleteAttribute }}</strong>
        </h5>
        <div slot="body">
          <span v-html="removeAttributeModalText"> </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="removeLinkedAttribute"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="delete-attribute-linked-with-article-modal">
        <h5 slot="header">
          <strong>Izbriši vrijednost atributa</strong>
        </h5>
        <div slot="body">
          <span v-html="removeAttributeModalText"> </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="removeAttributeLinkedWithArticle"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="attribute-article-link-modal"
      cssStyle="width: 1000px"
      >
        <h5 slot="header">
          <h4>Atribut: {{ selectedAttribute?.title }}</h4>
        </h5>
        <div slot="body">
          <div
            class="row align-items-center pb-3"
          >
              <div class="col-lg-12">
                <treeselect
                  v-model="articleId"
                  loadingText="Učitavanje..."
                  noResultsText="Nema rezultata"
                  searchPromptText="Unesite artikal"
                  :load-options="loadArticles"
                  :cache-options="false"
                  :async="true"
                  :options="articles"
                  :default-options="articles"
                  placeholder="Izaberite artikal"
                />
              </div>
          </div>

          <div class="form-group d-flex col-12">
            <div class="col-4">
              <img
                v-if="selectedAttributeArticle?.image"
                class="img-thumbnail article-attribute-thumbnail"
                :src="`${baseUrl}${selectedAttributeArticle?.image}`"
              />
              <div
                v-else
                style="background-color: lightgray;"
                class="img-thumbnail article-attribute-thumbnail text-light d-flex align-items-center
                justify-content-center"
              >
                <p v-if="selectedAttributeArticle == null">Bez slike</p>
                <p v-else class="text-light">Slika</p>
              </div>
            </div>

            <div class="col-8">
              <div>
                <div class=" row align-items-center mb-3">
                  <label class="col-2 control-label text-lg-end mb-0">
                    Naziv
                  </label>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      placeholder="Naziv"
                      v-model="selectedAttributeArticle.title"
                    />
                  </div>
                </div>

                <div class=" row align-items-center mb-3">
                  <label class="col-2 control-label text-lg-end mb-0">
                    Šifra
                  </label>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      placeholder="Šifra"
                      v-model="selectedAttributeArticle.code"
                    />
                  </div>
                </div>

                <div class=" row align-items-center mb-3">
                  <label class="col-2 control-label text-lg-end mb-0">
                    Cijena
                  </label>
                  <div class="col-3">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      placeholder="Cijena"
                      v-model.number="selectedAttributeArticle.price"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-default px-4 mx-2"
                data-bs-dismiss="modal"
                @click.prevent.stop="closeArticleAttributeModal()"
              >
                Odustani
              </button>
              <button
                type="button"
                class="btn btn-primary px-4"
                @click.prevent.stop="saveAttributeWithArticle()"
              >
                Dodaj
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal id="add-variation-modal" css-class="modal-xl">
        <h5 slot="header">
          <strong>{{ translations.addVariation }}</strong>
        </h5>
        <div slot="body">
          <div class="form-group row align-items-center mb-3">
            <div
              class="col col-4"
              :class="{
                'col-4': variationAttributes.length % 3 === 0,
                'col-6': variationAttributes.length % 2 === 0,
              }"
              v-for="item in variationAttributes"
              :key="item.id"
            >
              <label class="label">{{ item.label }}</label>
              <select class="form-control" :key="item.id" v-model="item.model">
                <option :value="null">Bilo koja vrijednost</option>
                <option :value="v.id" v-for="v in item.values" :key="v.id">
                  {{ v.label }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
              >Istaknuta slika</label
            >
            <div class="col-lg-7 col-xl-6">
              <input
                type="file"
                class="form-control"
                ref="highlightedImage"
                accept="image/*"
                @change="handlePhotoUpload"
              />
            </div>
          </div>

          <div class="form-group row align-items-center">
            <div class="col">
              <div
                id="dropzone-variations-form-image"
                class="dropzone-modern dz-square dz-clickable dropzone initialized"
              >
                <span class="dropzone-upload-message text-center">
                  <i class="bx bxs-cloud-upload"></i>
                  <b class="text-color-primary">Prevucite/učitajte</b> slike ovdje.
                  <span class="form-text">
                    Učitajte slike rezolucije 800px x 800px
                  </span>
                </span>
              </div>
            </div>
          </div>

          <div class="form-group row align-items-center mb-3"
            :class="{ 'has-danger': $v.selectedVariation.code.$anyError }"
          >
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              SKU
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="SKU"
                v-model="selectedVariation.code"
              />

              <form-error
                :model="$v.selectedVariation.code"
                :dirty="$v.selectedVariation.$dirty"
                label="SKU"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3"
            :class="{ 'has-danger': $v.selectedVariation.mpc.$anyError }"
          >
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Standardna cijena (KM)
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Standardna cijena"
                v-model="selectedVariation.mpc"
              />

              <form-error
                :model="$v.selectedVariation.mpc"
                :dirty="$v.selectedVariation.$dirty"
                label="Standardna cijena"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Dimenzije (DxŠxV) (cm)
            </label>

            <div class="col-lg-7 col-xl-6">
              <div class="row">
                <div class="col-lg-4 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    placeholder="Duzina"
                    v-model="selectedVariation.length"
                  />
                </div>

                <div class="col-lg-4 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-modern col-4"
                    placeholder="Sirina"
                    v-model="selectedVariation.width"
                  />
                </div>

                <div class="col-lg-4 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-modern col-4"
                    placeholder="Visina"
                    v-model="selectedVariation.height"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Kolicina na zalihi
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Kolicina na zalihi"
                v-model="selectedVariation.stockAmount"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Tezina (kg)
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Tezina (kg)"
                v-model="selectedVariation.weight"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Akcijska cijena
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Akcijska cijena"
                v-model="selectedVariation.salePrice"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Opis
            </label>
            <div class="col-lg-7 col-xl-6">
              <textarea
                type="text"
                class="form-control form-control-modern"
                placeholder="Opis"
                v-model="selectedVariation.description"
              />
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                class="btn btn-primary px-4"
                type="button"
                @click.prevent.stop="saveVariation(selectedVariation)"
              >
                Sacuvaj
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <!-- <modal id="update-variation-modal" css-class="modal-xl">
        <h5 slot="header">
          <strong>{{ translations.addVariation }}</strong>
        </h5>
        <div slot="body">
          <div class="form-group row align-items-center mb-3">
            <div
              class="col col-4"
              :class="{ 'col-4': selectedVariation.variationCombinations.length % 3 === 0, 'col-6': selectedVariation.variationCombinations.length % 2 === 0 }"
              v-for="item in selectedVariation.variationCombinations"
              :key="item.id">

                <label class="label">{{ variationAttributesObj[item.attributeId].label }}</label>
                <select class="form-control" :key="item.id" v-model="item.attributeValueId">
                  <option :value="null">Bilo koja vrijednost</option>
                  <option
                    :value="v.id"
                    v-for="v in variationAttributesObj[item.attributeId].values"
                    :key="v.id"
                  >
                    {{ v.label }}
                  </option>
                </select>

            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Istaknuta slika</label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="file"
                class="form-control"
                ref="highlightedImage2"
                accept="image/*"
                @change="handlePhotoUploadUpdateVariation"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              SKU
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="SKU"
                v-model="selectedVariation.code"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Standardna cijena (KM)
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Standardna cijena"
                v-model="selectedVariation.mpc"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Dimenzije (DxŠxV) (cm)
            </label>

            <div class="col-lg-7 col-xl-6">
              <div class="row">
                <div class="col-lg-4 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    placeholder="Duzina"
                    v-model="selectedVariation.length"
                  />
                </div>

                <div class="col-lg-4 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-modern col-4"
                    placeholder="Sirina"
                    v-model="selectedVariation.width"
                  />
                </div>

                <div class="col-lg-4 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-modern col-4"
                    placeholder="Visina"
                    v-model="selectedVariation.height"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Kolicina na zalihi
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Kolicina na zalihi"
                v-model="selectedVariation.stockAmount"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Tezina (kg)
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Tezina (kg)"
                v-model="selectedVariation.weight"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Akcijska cijena
            </label>
            <div class="col-lg-7 col-xl-6">
              <input
                type="text"
                class="form-control form-control-modern"
                placeholder="Akcijska cijena"
                v-model="selectedVariation.salePrice"
              />
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
              Opis
            </label>
            <div class="col-lg-7 col-xl-6">
              <textarea
                type="text"
                class="form-control form-control-modern"
                placeholder="Opis"
                v-model="selectedVariation.description"
              />
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                class="btn btn-primary px-4"
                type="button"
                @click.prevent.stop="saveVariation(selectedVariation)"
                data-bs-dismiss="modal"
              >Sacuvaj</button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal> -->
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import { format } from "date-fns";
import Datepicker from "vuejs-datepicker";

import Vue from 'vue';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import editor from "@tinymce/tinymce-vue";

import bs from "vuejs-datepicker/dist/locale/translations/bs";

import api from '@/services/api';
import helpers from '@/services/helpers';
import { translations } from '@/mixins';
import validations from './validation-schema/add';
import variationsValidations from './validation-schema/addArticleVariation';
import FormError from '../shared/form-errors/FormError.vue';
import config from '@/config';
import Modal from '../shared/modal/Modal.vue';
import LinkedArticles from './LinkedArticles.vue';
import MediaLibrary from './MediaLibrary.vue';
import MediaLibraryModalBody from '@/components/shared/MediaLibraryModal.vue';
import { EventBus } from '@/main';

const currentDate = new Date();

export default {
  name: 'AddArticle',
  mixins: [translations],
  validations: {
    ...validations,
    selectedVariation: variationsValidations,
  },
  components: {
    Datepicker,
    editor,
    FormError,
    Treeselect,
    Modal,
    LinkedArticles,
    MediaLibrary,
    MediaLibraryModalBody,
  },
  computed: {
    bs() {
      return bs;
    },
    articleStates() {
      return helpers.articleStates;
    },
    disabledDates() {
      const date = new Date();
      date.setDate(date.getDate() - 1);

      return {
        to: date,
      };
    },
    removeAttributeModalText() {
      return this.translations.areYouSureAttributeArticle;
    },
    appSettings() {
      return config.appSettings;
    },
    articles() {
      return this.$store.getters.getArticles.map((item) => {
        return {
          id: item.id,
          label: item.title,
          code: item.code,
          image: item.highlightedImageUrl,
          price: item.mpc,
          title: item.title
        };
      });
    },
    selectedAttributeArticle() {
      return this.articles.find((item) => item.id == this.articleId) ?? {
        title: '',
        code: '',
        price: ''
      };
    },
    categories() {
      return this.$store.getters.getSimplifiedCategories;
    },
    brands() {
      return this.$store.getters.getBrands;
    },
    taxes() {
      return this.$store.getters.getTaxes;
    },
    measurementUnits() {
      return this.$store.getters.getMeasurementUnits;
    },
    tabs() {
      return this.$store.getters.getTabs;
    },
    categoriesTreeView() {
      return this.$store.getters.getCategoriesTree;
    },
    areas() {
      const areas = this.$store.getters.getInterestsAreas;

      if (!areas.length) {
        return [];
      }

      const selectAll = {
        id: 0,
        label: 'Oznaci sve',
      };

      return [
        selectAll,
        ...areas.map((item) => {
          return {
            label: item.title,
            id: item.id,
          };
        }),
      ];
    },
    attributesObj() {
      return this.$store.getters.getAttributesAsObj;
    },
    attributes() {
      return this.$store.getters.getAttributes;
    },
    variationAttributes() {
      return this.linkedAttributes?.filter((item) => !item.linkWithArticle).map((item) => {
        const attribute = this.attributesObj[item.id];

        // Options come from the values picked on the attributes tab (attributeValues),
        // not from `model` which holds this modal's own per-attribute selection.
        const values = (item.attributeValues || []).map((a) => {
          const obj = attribute?.attributeProperties?.find((i) => i.id === a);

          return {
            id: a,
            label: obj?.label,
          };
        });

        return {
          id: item.id,
          label: attribute?.title,
          values,
          model: null,
        };
      }) || [];
    },
    companies() {
      const companies = this.$store.getters.getCompanies.map((item) => {
        return {
          id: item.id,
          label: item.title,
        };
      });
      return companies;
    },
    tags() {
      return this.$store.getters.getTags;
    },
  },
  data() {
    return {
      articleCodeExists: false,
      gallery: [],
      brand: {
        title: '',
        description: '',
      },
      reviewAllowed: true,
      minOrderQuantity: 1,
      maxOrderQuantity: 0,
      length: 0,
      width: 0,
      height: 0,
      articleState: 3,
      presentationAvailable: false,
      tagName: '',
      interestsAreasIds: [],
      baseUrl: config.baseUrl,
      searchField: '',
      showSearchResults: false,
      linkedArticles: [],
      linkedAttributes: [],
      dropzoneVariations: '',
      code: '',
      catalogNumber: '',
      title: '',
      description: '',
      shortDescription: '',
      nc: 0,
      vpc: 0,
      mpc: 0,
      unitOfMeasureId: 1,
      nettoWeight: null,
      bruttoWeight: null,
      disableSelling: false,
      disableSellingB2C: false,
      isNewArticleFromDate: new Date(),
      isNewArticleToDate: (new Date(currentDate)).setDate(currentDate.getDate() + 7),
      categoryIds: null,
      isVisibleOnWeb: true,
      isReplaceable: false,
      brandId: null,
      taxId: 2,
      videoUrl: '',
      editor: '',
      tabId: null,
      editors: [],
      // companyId: null,
      selectedDeleteAttribute: null,
      selectedDeleteAttributeLinkedWithArticle: null,
      selectedDeleteArticlePropertyId: null,
      selectedAttribute: null,
      selectedAttributeProperty: null,
      articleId: null,
      attributeArticleType: 1,
      highlightImageUrl: '',
      attributeArticleTypes: [
        {
          id: 1,
          label: 'Jednostavni',
        },
        {
          id: 2,
          label: 'Varijabilni',
        },
      ],
      attributeId: null,
      selectedVariation: {},
      variations: [],
      tagsIds: [],
      isNewArticle: false,
      orderQuantityRatio: 1,
      b2BProduct: true,
      b2CProduct: true,
      articleAvailableInDays: '',
    };
  },
  methods: {
    highlightImage(id) {
      const images = this.gallery;
      this.gallery = images.map((image) => {
        image.isHighlighted = false;
        return image;
      });

      const index = images.findIndex((image) => image.id === id);

      this.gallery[index].isHighlighted = true;
    },
    deleteImage(id) {
      this.gallery = this.gallery.filter((image) => image.id !== id);
    },
    handleMinOrderQuantity() {
      this.orderQuantityRatio = this.minOrderQuantity;
    },
    handleOrderQuantityRatio() {
      this.minOrderQuantity = this.orderQuantityRatio;
    },
    closeMediaLibraryModal() {
      $('#media-library').modal('hide');
    },
    closeUploadModal(modalId) {
      $(`#${modalId}`).modal('hide');
      EventBus.$emit(`clear-upload-modal-data:${modalId}`);
    },
    customFormatter(date) {
      return format(date, "dd.MM.yyyy.");
    },
    checkIfArticleCodeExists() {
      if (!this.code || !this.code.trim()) {
        this.articleCodeExists = false;
        return;
      }

      api.checkIfArticleCodeExists(0, this.code)
        .then(() => {
          // this.$toast.info(response?.data?.info);
          this.articleCodeExists = false;
        })
        .catch(() => {
          this.articleCodeExists = true;
        })
    },
    submitForm() {
      this.$v.$touch();

      // Gate on the article fields only, `selectedVariation` is validated by its own modal
      const articleFields = Object.keys(validations);

      if (articleFields.some((key) => this.$v[key].$invalid)) {
        this.$toast.error(this?.translations?.forms?.notValid);
        this.$nextTick(() => {
          let elem = document.querySelector('.has-danger');
          elem.scrollIntoView(true);
        });
        return;
      }

      const {
        title,
        description,
        code,
        catalogNumber,
        shortDescription,
        nc,
        vpc,
        mpc,
        unitOfMeasureId,
        nettoWeight,
        categoryIds,
        isVisibleOnWeb,
        isReplaceable,
        taxId,
        brandId,
        videoUrl,
        editors,
        interestsAreasIds,
        attributeArticleType,
        // companyId,
        isNewArticle,
        tagsIds,
        presentationAvailable,
        disableSelling,
        disableSellingB2C,
        bruttoWeight,
        articleState,
        isNewArticleFromDate,
        isNewArticleToDate,
        minOrderQuantity,
        maxOrderQuantity,
        length,
        width,
        height,
        reviewAllowed,
        gallery,
        orderQuantityRatio,
        b2BProduct,
        b2CProduct,
        articleAvailableInDays,
      } = this;

      const payload = {
        title,
        description,
        code,
        catalogNumber,
        shortDescription,
        nc,
        vpc,
        mpc,
        unitOfMeasureId,
        nettoWeight,
        categoryIds,
        isVisibleOnWeb,
        isReplaceable,
        taxId,
        brandId,
        videoUrl,
        editors,
        interestsAreasIds,
        attributeArticleType,
        // companyId,
        isNewArticle,
        tagsIds,
        presentationAvailable,
        disableSelling,
        disableSellingB2C,
        bruttoWeight,
        articleState,
        isNewArticleFromDate,
        isNewArticleToDate,
        minOrderQuantity,
        maxOrderQuantity: maxOrderQuantity || null,
        length,
        width,
        height,
        reviewAllowed,
        tabs: editors,
        mediaLibraryArticleImages: gallery.map((i) => ({
          ...i,
          mediaLibraryFileId: i.id
        })),
        orderQuantityRatio,
        b2BProduct,
        b2CProduct,
        articleAvailableInDays: articleAvailableInDays.trim().length === 0 ? null : articleAvailableInDays,
      };

      const isHighlighted = payload.mediaLibraryArticleImages.some(item => item.isHighlighted);

      if (!isHighlighted && payload.mediaLibraryArticleImages.length) {
        payload.mediaLibraryArticleImages[0].isHighlighted = true;
      }

      if (!payload.isNewArticle) {
        delete payload.isNewArticleFromDate;
        delete payload.isNewArticleToDate;
      } else {
        payload.isNewArticleFromDate = new Date(payload.isNewArticleFromDate);
        payload.isNewArticleToDate = new Date(payload.isNewArticleToDate);
      }

      api.createArticle(payload)
      .then((response) => {
        const requests = [];

        if (this.linkedArticles.length > 0) {
          const linkedArticlesIds = this.linkedArticles.map((item) => item.id);
          requests.push(
            api.createLinkedArticles({
              articleId: response.data.data,
              linkedArticlesIds,
            })
          );
        }

        if (this.linkedAttributes.length > 0) {
          const payload = [];

          this.linkedAttributes.forEach((item) => {
          if (item.attributePropertiesLinkedWithArticle && !item.attributePropertiesLinkedWithArticle.find((attr) => attr.id == null))
            payload.push({
              articleId: response.data.data,
              attributeId: item.attributeId,
              attributeValues: item.linkWithArticle ? 
              item.attributePropertiesLinkedWithArticle.map((prop) => ({
                attributeValueId: prop.id,
                linkedArticleId: prop.articleId,
              })) : item.attributeValues.map((value) => ({
                attributeValueId: value,
                linkedArticleId: null
              })),
            });
        });

        this.linkedAttributes.forEach((item) => {
          if (!item.attributePropertiesLinkedWithArticle )
            payload.push({
              articleId: response.data.data,
              attributeId: item.attributeId,
              attributeValues: item.attributeValues.map((value) => ({
                attributeValueId: value,
                linkedArticleId: null
              })),
            });
        });

          requests.push(api.createArticleAttributes(payload));

          // Only send variations when some exist, the API rejects an empty list
          if (this.variations.length > 0) {
            this.variations = this.variations.map((item) => {
              return {
                ...item,
                weight: parseFloat(item.weight, 10),
                height: parseFloat(item.height, 10),
                length: parseFloat(item.length, 10),
                width: parseFloat(item.width, 10),
                mpc: parseFloat(item.mpc, 10),
                salePrice: parseFloat(item.salePrice, 10),
                stockAmount: parseInt(item.stockAmount, 10),
                articleId: response.data.data,
              };
            });
            requests.push(api.createVariations(this.variations));
          }
        }

        if (requests.length > 0) {
          Promise.all(requests)
            .then(() => {
              this.$toast.info(response?.data?.info);
              this.$router.push({ name: 'Articles' });
            })
            .catch((err) => {
              this.$toast.error(err?.response?.data?.info || 'Desila se greška');
            });
        } else {
          this.$toast.info(response?.data?.info);
          this.$router.push({ name: 'Articles' });
        }
      })
      .catch((err) => {
        this.$toast.error(err?.response?.data?.info || 'Desila se greška');
      });
    },
    addTab() {
      if (!this.tabId) return;

      const exist = this.editors.find((tab) => tab.id === this.tabId);

      // There is already tab with that id in the list
      if (exist) return;

      const selectedTab = this.tabs.find((tab) => tab.id === this.tabId);
      selectedTab.content = '';
      selectedTab.tabId = this.tabId;
      this.editors.push(selectedTab);
    },
    addTag() {
      $('#add-tag').modal('show');
    },
    addBrand() {
      $('#add-brand').modal('show');
    },
    saveTag() {
      api.createTag({ title: this.tagName })
        .then((response) => {
          this.$toast.info(response?.data?.info);
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        })
        .finally(() => {
          $('#add-tag').modal('hide');
          this.tagName = '';
        });
    },
    saveBrand() {
      const { title, description } = this.brand;

      const formData = new FormData();

      formData.append('title', title);
      formData.append('description', description);

      if (this.$refs.brandImage.files[0]) {
        formData.append('Image', this.$refs.brandImage.files[0]);
      }
      api.createBrand(formData)
        .then((response) => {
          this.$toast.info(response?.data?.info);
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        })
        .finally(() => {
          $('#add-brand').modal('hide');
          this.brand.title = '';
          this.brand.description = '';
          this.$store.dispatch('getBrands', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
        });
    },
    removeTab(index) {
      this.editors.splice(index, 1);
    },
    saveAttributeWithArticle() {
      if (!this.articleId) {
        this.$toast.error('Odabir artikla je obavezan');
        return;
      }

      const attribute = this.linkedAttributes.find((item) => item.attributeId == this.attributeId)
      const selectedProperty = attribute.attributePropertiesLinkedWithArticle.find((item) => item.id === this.selectedAttributeProperty);

      if (!selectedProperty) {
        attribute.attributePropertiesLinkedWithArticle.push({
          id: this.selectedAttributeProperty,
          articleId: this.articleId,
          articleTitle: this.selectedAttributeArticle.title,
          articleCode: this.selectedAttributeArticle.code,
          articlePrice: this.selectedAttributeArticle.price,
          articleImage: this.selectedAttributeArticle.image,      
        })
      } else {
          selectedProperty.id = this.selectedAttributeProperty;
          selectedProperty.articleId = this.articleId;
          selectedProperty.articleTitle = this.selectedAttributeArticle.title;
          selectedProperty.articleCode = this.selectedAttributeArticle.code;
          selectedProperty.articlePrice = this.selectedAttributeArticle.price;
          selectedProperty.articleImage = this.selectedAttributeArticle.image;
          attribute.attributePropertiesLinkedWithArticle = [...attribute.attributePropertiesLinkedWithArticle.filter((item) => item.articleId != null)];
        }
      
      this.selectedAttribute = null;
      this.selectedAttributeProperty = null;
      this.attributeId = null;
      this.articleId = null;

      $('#attribute-article-link-modal').modal('hide');
    },
    closeArticleAttributeModal() { 
      this.selectedAttributeArticle = null;
      this.articleId = null;      

      $('#attribute-article-link-modal').modal('hide');
    },
    loadArticles({ callback, searchQuery }) {
      this.articleId = null;

      this.$store.dispatch('getArticles', {
        sortBy: 'title',
        isSortAscending: false,
        page: 1,
        retrieveAll: true,
        quickSearch: searchQuery.trim(),
        brandIds: [],
        categoryIds: [],
        attributeValuesIds: [],
        tagIds: [],
      }).then(() => {
          callback(null, this.articles);
        });
    },
    addAttribute() {
      if (!this.attributeId) {
        this.$toast.error('Izaberite atribut')
        return;
      }

      const attribute = this.attributesObj[this.attributeId];

      if (!attribute) return;
      
      this.$nextTick(() => {
        const attributeProperties = attribute.attributeProperties;

        if (attribute.linkWithArticle) {
          let attributePropertiesLinkedWithArticle = attribute.attributePropertiesLinkedWithArticle ?? [];

          attributePropertiesLinkedWithArticle.push({
            id: this.selectedAttributeProperty,
            articleId: this.articleId,
            articleTitle: '',
            articleCode: '',
            articlePrice: '',
            articleImage: '',
          });

          attributePropertiesLinkedWithArticle = attributePropertiesLinkedWithArticle.filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.id === item.id && t.articleId === item.articleId)
          );

          this.$set(attribute, 'attributePropertiesLinkedWithArticle', attributePropertiesLinkedWithArticle);
        }

        this.$set(attribute, 'attributeProperties', attributeProperties);
        this.$set(attribute, 'attributeValues', []);
        this.$set(attribute, 'attributeId', attribute.id);
        this.$set(attribute, 'model', []);

        let articleAttributes = this.linkedAttributes;

        if (articleAttributes.length === 0 && attribute.linkWithArticle == false) {
          articleAttributes.push(attribute);
        } else {
          const item = articleAttributes.find((i) => i.attributeId === attribute.id);
        
          if (!item || item.id != this.selectedAttributeProperty) {
            articleAttributes.push(attribute);
          } else if (item && item.linkWithArticle) {
            item.attributePropertiesLinkedWithArticle.push({
              id: this.selectedAttributeProperty,
              articleId: this.articleId,
              articleTitle: '',
              articleCode: '',
              articlePrice: '',
              articleImage: '',
            });

            item.attributePropertiesLinkedWithArticle = item.attributePropertiesLinkedWithArticle.filter(
              (item, index, self) =>
                index === self.findIndex((t) => t.id === item.id && t.articleId === item.articleId)
            );
          } else if (item && !item.linkWithArticle) {
            this.$toast.error('Atribut je već dodan');
          }
        }

        articleAttributes = articleAttributes.filter(
          (item, index, self) => index === self.findIndex((t) => t.attributeId === item.attributeId)
        );

        this.selectedAttribute = attribute;
        this.selectedAttributeProperty = null;

        this.$set(this.article, 'articleAttributes', articleAttributes);
      })

    },
    removeAttributeLinkedWithArticle() {
      const attribute = this.linkedAttributes.find((item) => item.attributeId == this.selectedDeleteAttributeLinkedWithArticle);

      attribute.attributePropertiesLinkedWithArticle = attribute.attributePropertiesLinkedWithArticle
      .filter((item) => item.id != this.selectedDeleteArticlePropertyId)

      if (attribute.attributePropertiesLinkedWithArticle.length == 0) {
        this.linkedAttributes = this.linkedAttributes.filter((item) => item.attributeId != attribute.attributeId)
      }
    },
    removeLinkedAttribute() {
      const attribute =
        this.linkedAttributes.find(
          (item) => item.attributeId == this.selectedDeleteAttribute
        );

        this.linkedAttributes = this.linkedAttributes.filter(
            (item) => item.attributeId != attribute.attributeId
          );
    },
    selectLinkedAttribute(attributeId) {
      this.selectedDeleteAttribute = attributeId;
    },
    selectAttributeLinkedArticle(attributeId, propertyId) {
      this.selectedDeleteAttributeLinkedWithArticle = attributeId;
      this.selectedDeleteArticlePropertyId = propertyId;
    },
    onAttributeChange() {
    },
    onAttributePropertySelect(node) {
      this.selectedAttributeProperty = node.id;

      const attribute = this.linkedAttributes.find((item) => item.attributeId == this.attributeId)

      if (attribute) {
        if (attribute.attributePropertiesLinkedWithArticle.find((item) => item.id == node.id)) {
          this.$toast.error('Vrijednost atributa je već dodana');
          return;
        }

        $('#attribute-article-link-modal').modal('show');
      }
    },
    handlePhotoUpload() {
      const file = this.$refs.highlightedImage.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (e) => {
        this.highlightImageUrl = e.target.result;
      };
    },
    handlePhotoUploadUpdateVariation() {
      const file = this.$refs.highlightedImage2.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (e) => {
        this.highlightImageUrl = e.target.result;
      };
    },
    addVariation() {
      this.selectedVariation = {
        title: '',
        code: '',
        enabled: false,
        // Prefilled from the article, same as the Edit screen
        mpc: this.mpc,
        salePrice: null,
        stockAmount: 0,
        weight: 0,
        width: 0,
        height: 0,
        length: 0,
        description: '',
      };

      this.$v.selectedVariation.$reset();
    },
    saveVariation(variation) {
      this.$v.selectedVariation.$touch();

      if (this.$v.selectedVariation.$invalid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      variation.variationCombinations = this.variationAttributes.map((item) => ({
        attributeId: item.id,
        attributeValueId: item.model,
      }));

      if (!variation.variationCombinations.length
        || variation.variationCombinations.some((item) => !item.attributeValueId)) {
        this.$toast.error('Molimo odaberite sve dostupne atribute prilikom kreiranja varijacije!');
        return;
      }

      // Images are optional, the file input and dropzone may be untouched
      const file = this.$refs.highlightedImage?.files?.[0];

      if (file && this.highlightImageUrl) {
        variation.highlightedImage = {
          file: this.highlightImageUrl.split(',')[1],
          fileName: file.name,
        };
      }

      variation.images = [];

      const files = this.dropzoneVariations?.[0]?.dropzone?.files || [];

      for (let i = 0; i < files.length; i++) {
        variation.images.push({
          file: files[i].dataURL.split(',')[1],
          fileName: files[i].name,
        });
      }

      this.variations.push(variation);

      $('#add-variation-modal').modal('hide');
    },
    handleChangeAreas(node) {
      if (node.id === 0) {
        // All selected
        if (this.interestsAreasIds.length === this.areas.length - 1) {
          Vue.nextTick(() => {
            this.interestsAreasIds = [];
          });
        } else {
          Vue.nextTick(() => {
            this.interestsAreasIds = this.areas
              .filter((i) => i.id !== 0)
              .map((i) => i.id);
          });
        }
      }
    },
    handleMpcChange() {
      this.vpc = parseFloat((this.mpc / 1.17).toFixed(2), 10);
    },
    handleVpcChange() {
      this.mpc = parseFloat((this.vpc * 1.17).toFixed(2), 10);
    },
  },
  mounted() {
    const ref = this;

    const initializeDropzoneVariations = function () {
      const dropzone = $('#dropzone-variations-form-image')
        .dropzone({
          url: './',
          addRemoveLinks: true,
          dictDefaultMessage: '',
          autoProcessQueue: false,
          init: function () {
            if ($('#dropzone-variations-form-image').hasClass('dz-filled')) {
              const dropzoneObj = Dropzone.forElement(
                '#dropzone-variations-form-image'
              );
              const mockFile = { name: 'Image Name', size: 12345 };
              dropzoneObj.displayExistingFile(
                mockFile,
                'img/products/product-1.jpg'
              );
            }
          },
        })
        .addClass('dropzone initialized');

      ref.dropzoneVariations = dropzone;
    };

    window.scrollTo({ top: 0, behavior: 'smooth' });

    // First Load
    $(document).ready(function () {
      initializeDropzoneVariations();
    });

    this.$store.dispatch('getSimplifiedCategories', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
    this.$store.dispatch('getMeasurementUnits', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
    this.$store.dispatch('getTaxes', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
    this.$store.dispatch('getBrands', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
    this.$store.dispatch('getTabs', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
    this.$store.dispatch('getInterestsAreas', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
    this.$store.dispatch('getCompanies', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
    this.$store.dispatch('getAttributes', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
    this.$store.dispatch('getTags', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
  },
};
</script>

<style lang="scss">
@import './assets/scss/article.scss';
@import './assets/scss/linked-articles.scss';
</style>
